import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from "react-router-dom";

export const NavBar = () => {
    return (
        <>
            <Navbar expand="lg" className="bg-body-tertiary">
                <Container>
                    <Navbar.Brand as={NavLink} to="/">Extract Frames</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto">
                            <Nav.Link
                                as={NavLink}
                                to="merge-video"
                            >
                                Merge Video
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="add-text"
                            >
                                Add Text
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="add-audio"
                            >
                                Add Audio
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="extract-audio"
                            >
                                Extract Audio
                            </Nav.Link>
                            <Nav.Link
                                as={NavLink}
                                to="trim-video"
                            >
                                Trim Video
                            </Nav.Link>
                            {/* <Nav.Link
                                as={NavLink}
                                to="brightness-video"
                            >
                                Brightness Video
                            </Nav.Link> */}
                           {/* <Nav.Link
                                as={NavLink}
                                to="all-in-one"
                            >
                                All In One
                            </Nav.Link> */}
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </>
    )
}
